import { siteStorageName } from "@crunchit/types";
import { saveToLocalStorage } from "@crunchit/utilities";
import { Navigate, useParams } from "react-router-dom";
import { roomNumberKey } from "utils/constants";

export default function Room() {
  const { roomNumber } = useParams();

  if (!roomNumber || roomNumber.includes(" ")) {
    return <Navigate to="/error" />;
  }

  saveToLocalStorage(siteStorageName, roomNumberKey, roomNumber);

  return <Navigate to="/" />;
}
